export const RequesterRoutes = {
    REQUESTS: `/requester/requests`,
    REQUEST: '/requester/request',
    REQUEST_BY_ID: '/requester/request/:id',
    COSTING: '/requester/costing',
    LIVE_PRODUCTS: '/requester/live-products',
    PRODUCTS: '/requester/request-detail',
    PRODUCTS_LIST: '/requester/request-detail/:id',
    ROOT: '/requester',
    REVIEWS: '/requester/reviews/:requestId/:productId',
    REQUEST_BREAKDOWN: '/requester/request-breakdown',
    REQUEST_BREAKDOWN_LIST: '/requester/request-breakdown/:id',
    SEARCH_BY_FSN: '/requester/search-by-fsn'
};

export const VendorRoutes = {
    ROOT: '/vendor',
    REQUESTS: '/vendor/requests',
    CREATE_QUOTATION: '/vendor/create-quotation/:id',
    PRODUCTS: '/vendor/request-detail',
    PRODUCTS_LIST: '/vendor/request-detail/:id',
    UPLOAD_3D_MODELS: '/vendor/upload-3d-models/:id',
    REVIEWS: '/vendor/reviews/:requestId/:productId',
    REQUEST_BREAKDOWN: '/vendor/request-breakdown',
    UPLOAD_STATUS: '/vendor/upload-status',
    REQUEST_BREAKDOWN_LIST: '/vendor/request-breakdown/:id'
};

export const OpsRoutes = {
    REQUESTS: `/ops/requests`,
    REQUEST: '/ops/request',
    REQUEST_BY_ID: '/ops/request/:id',
    REVIEWS: '/ops/reviews/:requestId/:productId',
    COSTING: '/ops/costing',
    PRODUCTS: '/ops/request-detail',
    PRODUCTS_LIST: '/ops/request-detail/:id',
    CREATE_QUOTATION: '/ops/create-quotation/:id',
    ROOT: '/ops',
    REQUEST_BREAKDOWN: '/ops/request-breakdown',
    REQUEST_BREAKDOWN_LIST: '/ops/request-breakdown/:id',
    SEARCH_BY_FSN: '/ops/search-by-fsn',
    SEARCH_BY_CSV: '/ops/search-by-csv',
    HOTSPOT: '/ops/hotspots/:id'
};

export const AdminRoutes = {
    ROOT: '/admin'
};

export const Routes = {
    ROOT: '/',
    INDEX: '/index*',
    LOGIN: '/login',
    SEARCH_BY_GLB: '/search-by-glb',
    PREVIEW: '/preview',
    GOLIVE: '/golive',
    AUTH_CALLBACK: '/authCallback',
    DASHBOARD: '/dashboard',
    REQUESTER_ROUTES: RequesterRoutes,
    OPS_ROUTES: OpsRoutes,
    VENDOR_ROUTES: VendorRoutes,
    ADMIN_ROUTES: AdminRoutes
};
